<template>
  <div class="app new-style">
    <div>
      <head1></head1>
    </div>
    <div class="banner">
      <img src="@/assets/images/ban.jpg" alt="" width="100%" height="100%" object-fit="cover" />
      <!-- <el-carousel height="800px" arrow="always" class="banner-carousel">
        <el-carousel-item v-for="item in imagesList" :key="item.id">
          <div @click="goBannerDetail(item.image.id)" class="banner-item">
            <img :src="item.image.path" alt="" width="100%" height="100%" object-fit="cover" />
          </div>
        </el-carousel-item>
      </el-carousel> -->
    </div>
    <div class="inner news">
      <div class="home-title news">
        最新动态
      </div>
      <div>
        <ul class="li-radio">
          <li @mouseover="onHover" :class="radio1 == 'overview' ? 'selectHover select' : 'select'">
            津旅资讯
          </li>
          <li @mouseover="onHover1" :class="radio1 == 'upgrade' ? 'selectHover select' : 'select'">
            国企党建
          </li>
          <li @mouseover="onHover2" :class="radio1 == 'version' ? 'selectHover select' : 'select'">
            信息公开
          </li>
          <div class="li-more" @click="goMore">了解更多
            <img src="@/assets/images/right-icon.png" alt="" />
          </div>
        </ul>
        <div v-show="radio1 == 'overview'" class="li-content">
          <div class="left">
            <el-carousel height="660px" class="news-carousel">
              <el-carousel-item v-for="item in messageListImg" :key="item.id">
                <a v-if="item.outerSiteUrl" :href="item.outerSiteUrl" target="_blank" :title="item.title">
                  <img :src="item.image.path" alt="" width="100%" height="100%" /></a>
                <span class="xxImg" v-else @click="innderDetail(item.id)">
                  <img :src="item.image.path" alt="" width="100%" height="100%" />
                </span>
                <div class="img-title">
                  <span>{{ item.title }}</span>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
          <div class="right">
            <ul class="news_list">
              <li class="news-title" v-for="(item, index) in messageList" :key="index">
                <div class="news-box">
                  <div>
                    <span class="list-title" v-if="item.outerSiteUrl">
                      <a :href="item.outerSiteUrl" target="_blank" :title="item.title">{{ item.title }}</a>
                    </span>
                    <span class="list-title" v-else @click="innderDetail(item.id)">
                      {{ item.title }}
                    </span>
                  </div>
                  <div class="news-desc">{{ item.showContent }}</div>
                </div>
                <div class="list-time">
                  <div>{{ handleListTime(item.createTime)[1] }}</div>
                  <div>{{ handleListTime(item.createTime)[0] }}</div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div v-show="radio1 == 'upgrade'" class="li-content">
          <div class="left">
            <el-carousel height="660px" width="880px" arrow="never" class="news-carousel">
              <el-carousel-item v-for="item in nationListImg" :key="item.id">
                <a v-if="item.outerSiteUrl" :href="item.outerSiteUrl" target="_blank" :title="item.title">
                  <img :src="item.image.path" alt="" width="100%" height="100%" /></a>
                <span class="list-title" v-else @click="innderDetail(item.id)">
                  <img :src="item.image.path" alt="" width="100%" height="100%" />
                </span>
                <div class="img-title">
                  <span>{{ item.title }}</span>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
          <div class="right">
            <ul class="news_list">
              <li class="news-title" v-for="(item, index) in nationList" :key="index">
                <div class="news-box">
                  <div>
                    <span class="list-title" v-if="item.outerSiteUrl">
                      <a :href="item.outerSiteUrl" target="_blank" :title="item.title">{{ item.title }}</a>
                    </span>
                    <span class="list-title" v-else @click="innderDetail(item.id)">
                      {{ item.title }}
                    </span>
                  </div>
                  <div class="news-desc">{{ item.showContent }}</div>
                </div>
                <div class="list-time">
                  <div>{{ handleListTime(item.createTime)[1] }}</div>
                  <div>{{ handleListTime(item.createTime)[0] }}</div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div v-show="radio1 == 'version'" class="li-content">
          <div class="left">
            <el-carousel height="660px" arrow="never" class="news-carousel">
              <el-carousel-item v-for="item in publicityListListImg" :key="item.id">
                <a v-if="item.outerSiteUrl" :href="item.outerSiteUrl" target="_blank" :title="item.title">
                  <img :src="item.image.path" alt="" width="100%" height="100%" v-if="item.outerSiteUrl" /></a>
                <span v-else @click="innderDetail(item.id)" class="xxImg">
                  <img :src="item.image.path" alt="" width="100%" height="100%" />
                </span>
                <div class="img-title">
                  <span>{{ item.title }}</span>
                </div>
              </el-carousel-item>
            </el-carousel>
          </div>
          <div class="right">
            <ul class="news_list">
              <li class="news-title" v-for="(item, index) in publicityList" :key="index">
                <div class="news-box">
                  <div>
                    <span class="list-title" v-if="item.outerSiteUrl">
                      <a :href="item.outerSiteUrl" target="_blank" :title="item.title">{{ item.title }}</a>
                    </span>
                    <span class="list-title" v-else @click="innderDetail(item.id)">
                      {{ item.title }}
                    </span>
                  </div>
                  <div class="news-desc">{{ item.showContent }}</div>
                </div>
                <div class="list-time">
                  <div>{{ handleListTime(item.createTime)[1] }}</div>
                  <div>{{ handleListTime(item.createTime)[0] }}</div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="inner column">
      <div class="home-title column">
        栏目板块
      </div>
      <div class="industry">
        <ul class="clearfix">
          <li>
            <div @click="jtjj()" class="fl">
              <img src="@/assets/images/Group Profile_icon.png" alt="" />
              <div class="transtion">
                <div>集团介绍</div>
                <div><span>Group Profile</span></div>
              </div>
              <div class="arrow"></div>
            </div>
          </li>
          <li>
            <div @click="jlzx()" class="fl">
              <img src="@/assets/images/news_icon.png" alt="" />
              <div class="transtion">
                <div>津旅资讯</div>
                <div><span>Tianjin Tourism Updates</span></div>
              </div>
              <div class="arrow"></div>
            </div>
          </li>
          <li>
            <div @click="gqdj()" class="fl">
              <img src="@/assets/images/dangjian_icon.png" alt="" />
              <div class="transtion">
                <div>国企党建</div>
                <div><span>Party Construction in SOEs</span></div>
              </div>
              <div class="arrow"></div>
            </div>
          </li>
          <li>
            <div @click="jlpp()" class="fl">
              <img src="@/assets/images/brand_icon.png" alt="" />
              <div class="transtion">
                <div>津旅品牌</div>
                <div><span>Tianjin Tourism Brand Portfolio</span></div>
              </div>
              <div class="arrow"></div>
            </div>
          </li>
          <li>
            <div @click="xxgk" class="fl">
              <img src="@/assets/images/information_icon.png" alt="" />
              <div class="transtion">
                <div>信息公开</div>
                <div><span>Information Disclosure</span></div>
              </div>
              <div class="arrow"></div>
            </div>
          </li>
          <li>
            <div @click="pxfz" class="fl">
              <img src="@/assets/images/talent_icon.png" alt="" />
              <div class="transtion">
                <div>人才引进</div>
                <div><span>Talent Recruitment Program</span></div>
              </div>
              <div class="arrow"></div>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div class="footer">
      <foot></foot>
    </div>
    <div class="footer-bottom">
      <bottom></bottom>
    </div>
  </div>
</template>

<script>
import foot from "./footer.vue";
import bottom from "./bottom.vue";
import head1 from "./head.vue";
import axios from "axios";
export default {
  name: "App",
  components: {
    foot,
    head1,
    bottom,
  },
  data() {
    return {
      imagesList: [],
      messageListImg: [],
      nationListImg: [],
      publicityListListImg: [],
      images2: [],
      messageList: [],
      nationList: [],
      publicityList: [],
      index: "1",
      radio1: "overview",
      industryInfo: {},
    };
  },
  methods: {
    pxfz() {
      this.$router.push("/rcyj?index1=" + 1);
    },
    xxgk() {
      this.$router.push("/xxgk");
    },
    jlpp() {
      this.$router.push("/jlpp?index1=" + "jlpp");
    },
    gqdj() {
      this.$router.push("/gqdj?index1=" + 5);
    },
    jlzx() {
      this.$router.push("/jlzx");
    },
    jtjj() {
      this.$router.push("/jtjs?index1=" + 1);
    },
    getIndustry() {
      axios.get("/jtg/home/synopsis").then((result) => {
        let res = JSON.parse(JSON.stringify(result.data));
        this.industryInfo = res.data;
        res.data.forEach((item, index) => {
          // console.log(item, index, 753);
          if (index <= 5) {
            this.messageList.push(item);
          } else if (index <= 11 && index > 5) {
            this.nationList.push(item);
          } else {
            this.publicityList.push(item);
          }
        });

        this.messageList = this.messageList.slice(0, 4);
        this.nationList = this.nationList.slice(0, 4);
        this.publicityList = this.publicityList.slice(0, 4);

        this.messageList.forEach((item) => {
          if (item.image.path != null) {
            this.messageListImg.push(item);
          }
        });

        this.nationList.forEach((item) => {
          if (item.image.path != null) {
            this.nationListImg.push(item);
          }
        });

        this.publicityList.forEach((item) => {
          if (item.image.path != null) {
            this.publicityListListImg.push(item);
          }
        });
      });
    },
    innderDetail(id) {
      this.$router.push("/innerDetail?index=" + id);
    },
    getSecarousel() {
      axios.get("/jtg/home/secarousel").then((result) => {
        let res = JSON.parse(JSON.stringify(result.data));
        this.images2 = res.data;
        this.images2.forEach((item) => {
          if (item.image.path != null) {
            this.imagesList.push(item);
          }
        });
      });
    },

    handleSelect(key, keyPath) {
      console.log(key, keyPath);
    },
    goBannerDetail(id) {
      if (id == 2) {
        this.$router.push("/gqdj?index1=" + 45);
      } else {
        this.$router.push("/bannerDetail?index=" + id);
      }
    },
    goJlzx() {
      this.$router.push("/jlzx");
    },
    goGqdj() {
      this.$router.push("/gqdj?index1=" + 5);
    },
    goXxgk() {
      this.$router.push("/xxgk?index1=" + 7);
    },
    // jtjj() {
    //   this.$router.push("/147");
    // },
    onHover() {
      this.radio1 = "overview";
    },
    onHover1() {
      this.radio1 = "upgrade";
    },
    onHover2() {
      this.radio1 = "version";
    },
    goMore() {
      if (this.radio1 == "overview") {
        this.goJlzx();
      } else if (this.radio1 == "upgrade") {
        this.goGqdj();
      } else if (this.radio1 == "version") {
        this.goXxgk();
      }
    },
    handleListTime(time) {
      const date = new Date(time);
      const year = date.getFullYear().toString().slice(2);
      const month = date.getMonth() + 1;
      const day = date.getDate();
      return [`${year}-${month}`, day];
    },
  },
  created() {
    this.getIndustry();
    this.getSecarousel();
  },
};
</script>

<style lang="scss" scoped>
.jicon {
  background: url(@/assets/images/icon-ba.png) no-repeat center left;
  padding-left: 12px;
}

.xxImg {
  cursor: pointer;
}

.footer-bottom {
  height: 50px;
  min-width: 1200px;
  background-color: #424242;
}

.tjlyjt {
  text-align: center;
  margin-top: 14px;
  font-size: 14px;
  color: #fff;
}

.line {
  width: 100%;
  height: 1px;
  margin: 17px 0;
  background-color: rgba(255, 255, 255, 0.3);
}

.footer-inner-right {
  margin-left: 50px;
  width: 310px;
}

.footer-inner-right-con {
  display: flex;
  margin-top: 40px;
}

.footer-inner-right-con-li {
  margin-right: 35px;
}

.footer-inner-con {
  width: 310px;
}

.footer-inner-one {
  display: flex;
  align-items: center;
}

.footer-inner-left {
  margin-right: 50px;
  width: 310px;
}

.banner-item {
  height: 580px;
  cursor: pointer;
}

.footer-inner-left-tit {
  /* position: absolute;
  left: 0;
  top: 8px; */
  margin-right: 10px;
  content: "";
  display: block;
  width: 10px;
  height: 10px;
  background-color: #00eb9b;
}

.footer-inner-left-title {
  font-size: 18px;
  color: #fff;
}

.footer-inner-left-title2 {
  color: #fff;
  font-size: 16px;
  margin-top: 18px;
}

.footer-inner-left-title1 a {
  color: #fff;
  font-size: 16px;
  text-decoration: none;
  cursor: pointer;
}

.footer-inner {
  display: flex;
  padding-top: 30px;
  margin-left: 462px;
}

.footer-con {
  height: 280px;
  min-width: 1200px;
  background-color: #004aba;
}

.footer-nav {
  height: 51px;
  min-width: 1200px;
  background-color: #023a8f;
}

.energy {
  margin-top: 38px;
  text-align: center;
}

.transtion {
  // font-size: 16px;
  // font-weight: 400;
  // color: #ffffff;
  transition: all 0.3s ease;
}

.clearfix {
  display: flex;

  justify-content: center;
  height: 158px;
  // li :hover {
  //   background: rgb(0, 206, 145);
  //   height: 158px;
  //   transform: scale(1.1);
  // }
}

.fl {
  margin-right: 20px;
  width: 159px;
  height: 158px;
  background: rgba(0, 108, 255, 0.45);
  cursor: pointer;
}

.fl:hover {
  background: rgb(0, 206, 145);
  // height: 158px;
  transform: scale(1.1);
}

.industry {
  width: 100%;
  height: 250px;
  margin-top: 36px;
  position: relative;
  padding-top: 25px;
  margin-bottom: 35px;
  background: url(@/assets/images/industry.png) no-repeat;
  background-size: 100% 100%;
}

.more {
  float: right;
  margin-top: 34px;
}

.pic-info {
  top: -60px;
  position: relative;
  z-index: 99;
  bottom: 0;
  line-height: 60px;
  background: rgba(51, 51, 51, 0.6);
  width: 96%;
  font-size: 18px;
  color: #fff;
  padding: 0 2%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.mor-btn {
  /* width: 175.88px; */
  cursor: pointer;
  text-align: center;
  line-height: 36px;
  background: #f7f7f7;
  color: #919493;
  padding: 0 50px;
  /* display: inline-block; */
}

.app {
  background-color: #fff;
}

.li-content {
  display: flex;
}

.list-title {
  cursor: pointer;
  float: left;
  font-size: 16px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 80%;
}

.list-title a {
  color: #919493;
  display: inline;
  text-decoration: none;
}

.news_list {
  width: 570px;
  height: 330px;
}

.news-title {
  line-height: 54px;
  border-bottom: 1px solid #ccc;
  font-size: 16px;
  color: #919493;
}

.left {
  width: 600px;
}

.right {
  margin-left: 30px;
}

.select {
  display: inline-block;
  // background: #f1f1f9;
  margin: 0 6px;
  font-size: 20px;
  width: 177px;
  line-height: 40px;
}

.selectHover {
  display: inline-block;
  // background: #f1f1f9;
  margin: 0 6px;
  font-size: 20px;
  width: 177px;
  line-height: 40px;
  background: url(@/assets/images/select.png) no-repeat;
  padding-bottom: 10px;
  color: #fff;
}

.banner {
  height: 580px;
}

.inner {
  margin: 70px auto;
  width: 1200px;
}

.li-radio {
  display: flex;
  justify-content: center;
  height: 45px;
  margin-bottom: 25px;
}

.li-radio li {
  text-align: center;
  display: inline-block;
  // background: #f1f1f9;
  margin: 0 6px;
  font-size: 20px;
  width: 177px;
  line-height: 40px;
  height: 40px;
}

.title {
  margin-bottom: 50px;
}

.a-title {
  color: #970f11;
  text-decoration: none;
  font-size: 30px;
  font-weight: bold;
  text-align: center;
}

.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 150px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}

::v-deep .el-carousel__indicators {
  z-index: 0 !important;
}

.logo-content {
  margin: 20px 0 20px 0;
  display: flex;
  justify-content: start;
  /* width: 1200px; */
  /* height: 100px; */
  /* line-height: 100px; */
  text-align: center;
}
</style>
<style lang="scss" scoped>
// 这css完全没法改，一个logo-content居然有31个，其中还有五个在相互覆盖
// 样式在这里进行覆盖，以前的css不能动
.new-style {
  .inner {
    padding-bottom: 120px;
    margin: 0;
    width: 100%;

    &.news {
      background-color: #f5f7fa;
      // background-image: url(@/assets/images/tianjinzhiyan_bg_img.png);
      background-repeat: no-repeat;
      background-position: left bottom;
      background-size: contain;
    }

    &.column {
      padding-bottom: 584px;
      background-image: url(@/assets/images/citySkyline_background.png);
      background-repeat: no-repeat;
      background-size: 101% 101%;
      background-position: -5px 0px;
    }

    >div {
      width: 1600px;
      margin: 0 auto;
    }
  }

  // ============最新资讯============
  .li-radio {
    position: relative;
    height: 84px;
    margin-bottom: 40px;
    justify-content: flex-start;

    &::after {
      content: "";
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 4px;
      background-color: #bfc5cc55;
    }

    li {
      height: 80px;
      line-height: 80px;
      background: transparent;
      font-size: 28px;
      font-weight: 500;
      width: 254px;
      padding: 0;
      border-bottom-color: #bfc5cc55;
      transition: color 0.3s ease, border-bottom-color 0.3s ease;

      &.selectHover {
        background: none;
        color: #206bd1;
        border-bottom: 4px solid #206bd1;
      }
    }

    .li-more {
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
      font-size: 20px;
      font-weight: 700;
      color: #206bd1;
      cursor: pointer;
      width: 122px;
      text-align: right;
      display: flex;
      align-items: center;
      justify-content: flex-end;

      img {
        margin-left: 6px;
        width: 30px;
        height: 5px;
        object-fit: contain;
      }
    }
  }

  // ============大轮播图============
  ::v-deep .banner-carousel .el-carousel__indicators {
    bottom: 20px;
    width: 80%;
    left: 10%;
    text-align: center;
    transform: none;
    z-index: 2 !important;

    .el-carousel__button {
      width: 120px;
      height: 8px;
      opacity: 1;
      background-color: #FFFFFF99;
    }

    .el-carousel__indicator--horizontal.is-active .el-carousel__button {
      background-color: #206bd199;
    }
  }

  .banner-item,
  .banner {
    height: 800px;
  }

  // ============最新资讯 内容 ============
  .li-content {
    img {
      object-fit: cover;
    }

    .left {
      width: 880px;
      height: 660px;
      flex-shrink: 0;
    }

    // 轮播
    ::v-deep .news-carousel .el-carousel__indicators {
      bottom: 20px;
      width: 20%;
      right: 24px;
      text-align: right;
      transform: none;
      z-index: 2 !important;
      left: auto;

      .el-carousel__indicator {
        padding: 12px 8px;

        .el-carousel__button {
          width: 16px;
          height: 16px;
          border-radius: 50%;
          background-color: #00000066;
          opacity: 1;
        }

        &.is-active {
          .el-carousel__button {
            background-color: #FFFFFFCC;
          }
        }
      }
    }

    .right {
      margin: 0;
      flex: 1;
      padding-left: 40px;
      overflow: hidden;
    }

    .img-title {
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 100px;
      line-height: 100px;
      padding-left: 24px;
      font-size: 28px;
      font-weight: 700;
      color: #fff;
      background: linear-gradient(90deg,
          rgba(32, 107, 209, 0.8) 55%,
          rgba(32, 107, 209, 0.4) 100%);

      span {
        display: inline-block;
        width: 80%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }


    .news-box {
      &>div:first-child {
        height: 36px;
      }
    }

    .news_list {
      width: 100%;
      height: auto;
    }

    .news-desc {
      font-weight: 400;
      font-size: 18px;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      /* 最多显示两行 */
      overflow: hidden;
      line-height: 28px;
      padding-top: 16px;
      color: #00000099;
    }

    .news-title {
      position: relative;
      border: 0;
      background-color: #fff;
      margin-bottom: 14px;
      height: 128px;
      padding: 24px 24px 24px 143px;
      box-sizing: border-box;
      overflow: hidden;

      &::after {
        content: "";
        position: absolute;
        left: 0;
        bottom: 0;
        width: 100%;
        height: 4px;
        background-color: #206bd1;
        transition: transform 0.3s ease;
        transform: translateX(-100%);
      }

      &:hover {
        &::after {
          transform: translateX(0);
        }
      }

      .list-title,
      .list-title a {
        color: #000000;
      }

      .list-title {
        font-weight: 700;
        font-size: 24px;
        line-height: 36px;
        float: none;
        display: inline-block;
        overflow: hidden;
        width: 100%;
      }

      .list-time {
        position: absolute;
        height: 106px;
        width: 95px;
        background-color: #edeff2;
        left: 24px;
        top: 24px;
        text-align: center;
        font-family: Century Gothic Paneuropean;

        >div:first-child {
          font-size: 40px;
          line-height: 64px;
          height: 64px;
          font-weight: 800;
          color: #000000;
        }

        >div:last-child {
          font-size: 20px;
          line-height: 42px;
          height: 42px;
          color: #ffffffcc;
          font-weight: 600;
          background-color: #206bd1;
        }
      }
    }
  }

  // ============栏目板块============
  .industry {
    background: none;

    .clearfix {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 32px;

      .fl {
        position: relative;
        width: 100%;
        height: 141px;
        background-color: #F5F7FA;
        font-size: 24px;
        font-weight: 700;
        line-height: 36px;
        display: flex;
        padding: 40px;
        box-sizing: border-box;
        overflow: hidden;

        &::after {
          content: "";
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 4px;
          background-color: #206BD1;
          transition: transform 0.3s ease;
          transform: translateX(-100%);
        }

        img,
        .arrow,
        .arrow::before,
        .arrow::after {
          display: flex;
          position: relative;
          flex-shrink: 0;
          width: 60px;
          height: 60px;
        }

        .arrow {
          transition: transform 0.3s ease;

          &::before,
          &::after {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            transition: opacity 0.3s ease;
          }

          &::before {
            background-image: url(@/assets/images/Icon_60px_nor_arrow.png);
            opacity: 1;
          }

          &::after {
            background-image: url(@/assets/images/Icon_60px_sel_arrow.png);
            opacity: 0;
          }
        }

        .transtion {
          flex: 1;
          color: #000000;
          padding-left: 8px;
          box-sizing: border-box;
          font-weight: 700;
          font-size: 24px;

          &>div:first-child {
            line-height: 40px;
          }

          &>div:last-child {
            line-height: 16px;
          }

          span {
            font-family: Century Gothic Paneuropean;
            font-weight: 400;
            font-size: 16px;
            color: #00000099;
          }
        }

        &:hover {
          transform: none;

          &::after {
            transform: translateX(0);
          }

          .arrow {
            transform: translateX(-14px);

            &::before {
              opacity: 0;
            }

            &::after {
              opacity: 1;
            }
          }
        }
      }
    }
  }
}

// ============标题============
.home-title {
  height: 170px;
  padding-top: 18px;
  background-repeat: no-repeat;
  background-position: center;
  // &.news {
  //   background-image: url(@/assets/images/LastestNewsTitle_img.png);
  // }
  // &.column {
  //   background-image: url(@/assets/images/ColumnSectionTitle_img.png);
  // }
  font-family: Source Han Sans CN;
  font-weight: 700;
  font-size: 32px;
  color: #22439D;
  text-align: center;
  line-height: 170px;
}
</style>